import { getRequest } from 'src/shared/AppUtils';

export function getSnpBookNews() {
  return getRequest('Catalog/GetHomePageCatalogContent');
}

export function getBookNewsss() {
  return getRequest('/api/Catalog/GetHomePageCatalogContent');
}
